import React from "react";
import "./aboutus.css";
import aboutusimage from "../../images/aboutusimage.jpg";
export default function Aboutus() {
  return (
    <div className="kingabout">
      <div className="sky">
        <img className="aboutusleft" src={aboutusimage} alt="" />
        <div className="leftright">
          <div className="left1">
            <h1>About us</h1>
            <p>
              Acejay Auto ltd is a team of passionate engineering teams and
              technicians, who have passion in the automotive industry.
            </p>

            <p>
              We are one of the leading auto repair shops serving customers in
              Kenya. All mechanic services are performed by highly qualified
              mechanics.
            </p>
          </div>
          <div className="right1">
            <div>
              <button className="searchbutt">Search...</button>
              <div className="searchicon"></div>
            </div>
            <div className="line1"></div>
            <div className="linkslinks">Links</div>
            <li className="hommee">Home</li>
          </div>
        </div>
      </div>
      <div className="middle1">
        <p>
          Every job is personal. f you want the quality you would expect from
          the dealership, but with a more personal and friendly atmosphere, you
          have found it. Just call us if you have a breakdown or need
          assistance. we offer Towing Services, Battery Boost Service, Flat Tyre
          Service, Lockout Service, Off-Road Recovery and Pull Out
        </p>
        <p>
          We undertake major and minor repairs of all types of light vehicles,
          specializing in 4x4, European, American and Japanese vehicles. Our
          mechanics are certified and well experiences and have the latest
          Computer Diagnostic and Scanning Tools.We insist on only genuine parts
          and accessories.
        </p>
        <p>
          From interior cleaning to changing the upholstery or carrying out
          repairs, we ensure that only the best materials and processes are
          used, making your vehicle look and feel fresh.Our Services
          Include;Interior Cleaning, Upholstery repair and replacement, Roof
          Lining Replacement. We are a fully fledged and registere Our Company
          was incorporated and duly registered back in June 1998 and are now
          very specialized and experienced in motor vehicle diagnostics,
          mechanical repairs, maintenance service, accident repairs plus
          professional spray painting.
        </p>
        <h2>Vision</h2>
        <p>To be a world-class provider of Vehicle repair servies</p>
        <h2>Mission</h2>
        <p>
          To provide leading technology and cost-effective solutions in vehicle
          and car repair
        </p>
        <h2>Our services</h2>
      </div>
      <div className="down1">
        <div className="mwanzo">
          <li>Mechanics</li>
          <li>Welding and fabricaton</li>
          <li>Car interior decor</li>
        </div>
        <div className="katikati">
          <li>Spray painting</li>
          <li>Buffing</li>
          <li>Panel beating</li>
        </div>
        <div className="mwisho">
          <li>Car electrical services</li>
          <li>Fitting</li>
          <li>Selling new and used cars</li>
        </div>
      </div>
    </div>
  );
}
